'use strict';
import sliders from '../../../src/js/shared/sliders';

const $ = jQuery.noConflict();
$(function() {

	const recipesListing = {

		section: null,
		panel: null,
		xhr: null,
		requestId: 0,
		maxVisibleSubcats: 8,
		subcatsMediaQuery: window.matchMedia('(max-width: 575px)'),
		pagesMediaQuery: window.matchMedia('(max-width: 399px)'),

		init: function() {
			const _this = this;

			this.section = document.querySelector('.js-recipes-listing');
			if (!this.section) return;

			this.panel = this.section.querySelector('.js-recipes-panel');
			if (!this.panel) return;

			this.bindClicks();
			this.initCategoriesSlider();
			this.updateSubcats();
			this.updatePagination();
			window.addEventListener('resize', function() {
				_this.updateSubcats();
				_this.updatePagination();
			});
		},

		// below 992px the category cards become a swipeable slick slider (no arrows);
		// init/destroy is managed manually — slick's own "unslick" breakpoint is unreliable
		initCategoriesSlider: function() {
			const $categories = $('.js-recipes-categories');
			if (!$categories.length || $categories.children().length < 2) return;

			const mediaQuery = window.matchMedia('(max-width: 991px)');

			const toggleSlider = function() {
				const isInitialized = $categories.hasClass('slick-initialized');

				if (mediaQuery.matches && !isInitialized) {
					sliders.initializeSlider('.js-recipes-categories', {
						slidesToShow: 6,
						slidesToScroll: 1,
						infinite: false,
						autoplay: false,
						speed: 300,
						arrows: false,
						dots: false,
						responsive: [
							{
								breakpoint: 767,
								settings: {
									slidesToShow: 4
								}
							},
							{
								breakpoint: 576,
								settings: {
									slidesToShow: 3
								}
							},
							{
								breakpoint: 500,
								settings: {
									slidesToShow: 2
								}
							}
						]
					});
					return;
				}

				if (!mediaQuery.matches && isInitialized) {
					$categories.slick('unslick');
				}
			};

			toggleSlider();
			window.addEventListener('resize', toggleSlider);
		},

		// on mobile show max 8 subcategories, the rest hides behind a "+N More" toggle
		updateSubcats: function() {
			const _this = this;
			const list = this.panel.querySelector('.recipes-listing__subcats');
			if (!list) return;

			const items = Array.prototype.slice.call(
				list.querySelectorAll('.recipes-listing__subcats-item:not(.recipes-listing__subcats-more-item)')
			);
			let moreItem = list.querySelector('.recipes-listing__subcats-more-item');
			const hiddenCount = items.length - this.maxVisibleSubcats;

			// desktop or few subcategories: show everything, drop the toggle
			if (!this.subcatsMediaQuery.matches || hiddenCount < 1) {
				items.forEach(function(item) {
					item.classList.remove('is-hidden');
				});
				if (moreItem) moreItem.remove();
				list.classList.remove('is-expanded');
				return;
			}

			const expanded = list.classList.contains('is-expanded');
			items.forEach(function(item, index) {
				item.classList.toggle('is-hidden', !expanded && index >= _this.maxVisibleSubcats);
			});

			if (!moreItem) {
				moreItem = document.createElement('li');
				moreItem.className = 'recipes-listing__subcats-item recipes-listing__subcats-more-item';
				moreItem.innerHTML = '<button type="button" class="recipes-listing__subcats-more js-recipes-subcats-more"></button>';
				list.appendChild(moreItem);
			}
			moreItem.querySelector('.js-recipes-subcats-more').textContent = expanded
				? 'Less'
				: '+' + hiddenCount + ' More';
		},

		// on mobile show a capped number of page numbers (3 below 400px, 4 below 576px),
		// sliding the window so the current page stays visible; prev/next are left untouched
		// (WP already hides them on the first/last page)
		updatePagination: function() {
			const nav = this.panel.querySelector('.pagination-nav');
			if (!nav) return;

			const dots = Array.prototype.slice.call(nav.querySelectorAll('.page-numbers.dots'));
			const numbers = Array.prototype.slice.call(
				nav.querySelectorAll('.page-numbers:not(.prev):not(.next):not(.dots)')
			);

			const maxVisiblePages = this.pagesMediaQuery.matches ? 3 : 4;

			// desktop or few enough pages: show everything, drop the mobile truncation
			if (!this.subcatsMediaQuery.matches || numbers.length <= maxVisiblePages) {
				dots.forEach(function(dot) {
					dot.classList.remove('is-hidden');
				});
				numbers.forEach(function(number) {
					number.classList.remove('is-hidden');
				});
				return;
			}

			dots.forEach(function(dot) {
				dot.classList.add('is-hidden');
			});

			const currentIndex = numbers.findIndex(function(number) {
				return number.classList.contains('current');
			});
			const maxStart = numbers.length - maxVisiblePages;
			const start = Math.min(Math.max((currentIndex === -1 ? 0 : currentIndex) - 1, 0), maxStart);

			numbers.forEach(function(number, index) {
				number.classList.toggle('is-hidden', index < start || index >= start + maxVisiblePages);
			});
		},

		// tab-like switching without page reloads (categories, subcategories, pagination)
		bindClicks: function() {
			const _this = this;

			this.section.addEventListener('click', function(event) {
				// category tabs
				const category = event.target.closest('.js-recipes-category');
				if (category) {
					event.preventDefault();
					if (category.classList.contains('is-active')) return;

					_this.setActiveCategory(category);
					_this.load({
						category: category.getAttribute('data-category') || '',
						subcategory: '',
						page: 1
					}, category.href, false);
					return;
				}

				// "+N More" subcategories toggle
				const moreButton = event.target.closest('.js-recipes-subcats-more');
				if (moreButton) {
					const list = _this.panel.querySelector('.recipes-listing__subcats');
					if (list) {
						list.classList.toggle('is-expanded');
						_this.updateSubcats();
					}
					return;
				}

				// subcategory links
				const subcategory = event.target.closest('.js-recipes-subcat');
				if (subcategory) {
					event.preventDefault();
					_this.load({
						category: subcategory.getAttribute('data-category') || '',
						subcategory: subcategory.getAttribute('data-subcategory') || '',
						page: 1
					}, subcategory.href, false);
					return;
				}

				// pagination links
				const pageLink = event.target.closest('.pagination-nav a.page-numbers');
				if (pageLink) {
					event.preventDefault();
					const url = new URL(pageLink.href, window.location.origin);
					_this.load({
						category: url.searchParams.get('category') || '',
						subcategory: url.searchParams.get('subcategory') || '',
						page: parseInt(url.searchParams.get('paged') || '1', 10)
					}, pageLink.href, true);
				}
			});
		},

		// highlight the clicked category card
		setActiveCategory: function(activeCard) {
			this.section.querySelectorAll('.js-recipes-category').forEach(function(card) {
				card.classList.toggle('is-active', card === activeCard);
			});
		},

		// fetch the re-rendered panel and swap it in
		load: function(params, url, scrollToGrid) {
			const _this = this;

			if (this.xhr) this.xhr.abort();
			this.panel.classList.add('is-loading');
			const requestId = ++this.requestId;

			this.xhr = $.ajax({
				method: 'POST',
				url: window.fwsLocalized.ajaxUrl,
				data: {
					action: 'fws-recipes-listing-filter',
					category: params.category,
					subcategory: params.subcategory || '',
					page: params.page || 1,
					// eslint-disable-next-line camelcase
					per_page: _this.section.getAttribute('data-per-page') || 9,
					// eslint-disable-next-line camelcase
					base_url: _this.section.getAttribute('data-base-url') || ''
				},
				success: function(response) {
					if (!response || !response.data || !response.data.html) return;

					_this.swapPanel(response.data.html, url, scrollToGrid, requestId);
				},
				error: function(jqXHR, textStatus) {
					// abort just means a newer request has already taken over
					if (textStatus === 'abort') return;

					// graceful fallback: regular navigation
					_this.panel.classList.remove('is-loading');
					if (url) window.location.href = url;
				}
			});
		},

		// preload every image in the new markup off-DOM first, then swap it in all at once —
		// avoids recipe card thumbnails popping in one by one as they finish downloading
		swapPanel: function(html, url, scrollToGrid, requestId) {
			const _this = this;
			const temp = document.createElement('div');
			temp.innerHTML = html;
			const images = Array.prototype.slice.call(temp.querySelectorAll('img'));

			let settled = false;
			const reveal = function() {
				if (settled || requestId !== _this.requestId) return;
				settled = true;

				_this.panel.innerHTML = html;
				_this.updateSubcats();
				_this.updatePagination();
				_this.panel.classList.remove('is-loading');
				if (url) window.history.pushState({}, '', url);

				if (scrollToGrid) {
					const grid = _this.panel.querySelector('.js-recipes-grid') || _this.panel;
					_this.scrollToElement(grid);
				}
			};

			if (!images.length) {
				reveal();
				return;
			}

			let remaining = images.length;
			const onImageSettled = function() {
				remaining -= 1;
				if (remaining <= 0) reveal();
			};

			images.forEach(function(img) {
				if (img.complete) {
					onImageSettled();
					return;
				}
				img.addEventListener('load', onImageSettled, {once: true});
				img.addEventListener('error', onImageSettled, {once: true});
			});

			// safety net: never leave the panel hidden if an image stalls
			window.setTimeout(reveal, 4000);
		},

		// scrollIntoView('start') hides the target's top edge under the fixed .site-header;
		// offset by its current (responsive/is-sticky) height instead
		scrollToElement: function(el) {
			const header = document.querySelector('.site-header');
			const offset = header ? header.offsetHeight : 0;
			const top = el.getBoundingClientRect().top + window.pageYOffset - offset - 16;

			window.scrollTo({top: top, behavior: 'smooth'});
		},
	};

	recipesListing.init();

});